import Heading from "../ui/Heading";
import DocumentUploadForm from "../features/business_profile/DocumentUploadForm";
import {
  BusinessProfileFormPart1,
  BusinessProfileFormPart2,
} from "../features/business_profile/BusinessProfileForm";
import PageLayout from "../ui/PageLayout";

import DocumentFolderView from "../features/business_profile/DocumentFolderView";
import ButtonHelp from "../ui/ButtonHelp.jsx";
import InfoTooltip from "@/ui/InfoTooltip";

import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const steps = [
  {
    title: "Company Profile",
    content:
      "Enter your company information to tailor our platform to your business",
    target: "#company-profile",
    placement: "center",
    disableBeacon: true,
  },
  {
    title: "Profile Information",
    content: "Describe your company's services. Be as detailed as possible",
    target: "#cp-profile-info-disc",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    title: "Profile Information",
    content:
      "List all the locations where your business operates to help us provide more relevant proposals",
    target: "#cp-profile-info-loc",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    title: "Update",
    content: "Click to save your changes",
    target: "#cp-profile-info-update",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    title: "Upload Docs",
    content:
      "Upload documents like past proposals, contracts, or project reports to enhance your AI-generated proposals",
    target: "#cp-profile-doc-upload-file",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    title: "Upload Docs",
    content: "The uploaded file will be saved under the selected document type",
    target: "#cp-profile-doc-upload-type",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    title: "Submit",
    content: "Submit to save your progress",
    target: "#cp-profile-doc-upload-submit",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    title: "Saved Docs",
    content: "Find all your uploaded documents here",
    target: "#cp-profile-doc-upload-table",
    placement: "top-end",
    disableBeacon: true,
  },
];

export default function CompanyProfileLayout({ children }) {
  return (
    <div>
      <PageLayout
        heading="Company Profile"
        description="Manage your company information and documents."
      >
        <Tabs defaultValue="basic-info">
          <TabsList>
            <TabsTrigger value="basic-info">Profile Information </TabsTrigger>
            <TabsTrigger value="business-description">
              Business Description
            </TabsTrigger>
            <TabsTrigger value="documents">Documents</TabsTrigger>
          </TabsList>
          <TabsContent value="basic-info">
            <div className="flex-grow">
              <BusinessProfileFormPart1 />
            </div>
          </TabsContent>
          <TabsContent value="business-description">
            <div className="flex-grow">
              <BusinessProfileFormPart2 />
            </div>
          </TabsContent>
          <TabsContent value="documents">
            <div className="flex-grow">
              <div className="flex items-center space-x-2 mb-2">
                <Heading
                  as="h2"
                  className="font-bold"
                  id="cp-profile-doc-upload"
                >
                  Document Upload
                </Heading>
                <InfoTooltip description="Upload essential documents such as capability statements, past performance records, and other important files." />
              </div>

              <DocumentUploadForm />
              <Heading
                as="h2"
                className="font-bold mb-2"
                id="cp-profile-doc-upload"
              ></Heading>
              <DocumentFolderView />
            </div>
          </TabsContent>
        </Tabs>
      </PageLayout>
      <ButtonHelp steps={steps} />
    </div>
  );
}
